import React from "react";
import { GroupContext } from "../../context";
import IGroup from "../../models/group";

type TProps = {
  children: React.ReactNode;
};

export default (props: TProps) => {
  const [groups, setGroups] = React.useState<undefined | IGroup[]>(undefined);

  return <React.Fragment>
    <GroupContext.Provider value={{
      groups, setGroups
    }}>{props.children}</GroupContext.Provider>
  </React.Fragment>;
};
